import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";

const DesktopBannerContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  min-height: 90px;
  margin: 0 auto;
  background: transparent;
  z-index: 1050;
  
  @media (max-width: 768px) {
    display: none;
  }
`;

const MobileBannerContainer = styled.div`
  display: none; /* Masquer complètement sur mobile */
  
  @media (min-width: 769px) {
    display: none;
  }
`;

/**
 * Bannière responsive en haut de page :
 * - 728x90 sur desktop (clé fournie)
 * - 320x50 sur mobile (clé à renseigner ensuite)
 */
export const BannerTop: React.FC = () => {
  // Desktop (728x90)
  const desktopRef = useRef<HTMLDivElement>(null);
  // Mobile (320x50)
  const mobileRef = useRef<HTMLDivElement>(null);

  // Clés Adsterra (à adapter si besoin)
  const desktopKey = "b31e0af6f8bb2b1f4605f6191573095c";
  const desktopDomain = "pl21544828.toprevenuegate.com";
  // Remplace la clé mobile ci-dessous par la tienne !
  const mobileKey = "427016ab247b433d685ca86dc706c60c";
  const mobileDomain = "traverseseven.com";

  // Desktop script (728x90)
  useEffect(() => {
    if (!desktopRef.current) return;
    desktopRef.current.innerHTML = "";
    const scriptConfig = document.createElement("script");
    scriptConfig.type = "text/javascript";
    scriptConfig.innerHTML = `
      atOptions = {
        'key' : '${desktopKey}',
        'format' : 'iframe',
        'height' : 90,
        'width' : 728,
        'params' : {}
      };
    `;
    const scriptLoader = document.createElement("script");
    scriptLoader.type = "text/javascript";
    scriptLoader.src = `//${desktopDomain}/${desktopKey}/invoke.js`;
    scriptLoader.async = true;
    desktopRef.current.appendChild(scriptConfig);
    desktopRef.current.appendChild(scriptLoader);
  }, []);

  // Mobile script (320x50)
  useEffect(() => {
    if (!mobileRef.current || !mobileKey) return;
    mobileRef.current.innerHTML = "";
    const scriptConfig = document.createElement("script");
    scriptConfig.type = "text/javascript";
    scriptConfig.innerHTML = `
      atOptions = {
        'key' : '${mobileKey}',
        'format' : 'iframe',
        'height' : 50,
        'width' : 320,
        'params' : {}
      };
    `;
    const scriptLoader = document.createElement("script");
    scriptLoader.type = "text/javascript";
    scriptLoader.src = `//${mobileDomain}/${mobileKey}/invoke.js`;
    scriptLoader.async = true;
    mobileRef.current.appendChild(scriptConfig);
    mobileRef.current.appendChild(scriptLoader);
  }, [mobileKey]);

  return (
    <>
      <DesktopBannerContainer>
        <div ref={desktopRef} style={{ width: 728, height: 90 }} />
      </DesktopBannerContainer>
      {mobileKey && (
        <MobileBannerContainer>
          <div ref={mobileRef} style={{ width: 320, height: 50 }} />
        </MobileBannerContainer>
      )}
    </>
  );
};

export default BannerTop;
